import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { useCreateRetailer } from "./useCreateRetailer";
import Form, { RetailerFormProps } from "./Form";

const FORM_ID = "create-retailer-form";

type Props = Pick<ModalProps, "isOpen" | "onClose"> &
  Pick<RetailerFormProps, "defaultValues"> & {
    isAdmin?: boolean;
    onCompleted: (id: UUID) => void;
  };

export default function CreateRetailerModal({
  defaultValues,
  isAdmin,
  isOpen,
  onClose,
  onCompleted,
}: Props) {
  const { brandId, handleValidSubmit, isSaving } = useCreateRetailer(isAdmin);

  return (
    <Modal {...{ isOpen, onClose }} size="md" blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add New Retailer</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Form
            defaultValues={defaultValues}
            formId={FORM_ID}
            isAdmin={isAdmin}
            onSubmit={(evt) => {
              evt.stopPropagation();
            }}
            onValidSubmit={(formData, context) =>
              handleValidSubmit(formData, context).then((result) => {
                const newId = result?.data?.createRetailer?.retailer?.id;
                if (newId) onCompleted(newId);
              })
            }
            parentSelectFilter={{
              forBrandId: { equalTo: isAdmin ? null : brandId },
            }}
          />
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button
            type="submit"
            size="sm"
            colorScheme="pinkButton"
            leftIcon={<AddIcon />}
            isLoading={isSaving}
            form={FORM_ID}
          >
            Add New Retailer
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
